CashMovementCreateController.$inject = [
    '$uibModalInstance',
    'Club',
    'moment',
    'alerts',
    'serverDateTimeFormat',
    'ngModel',
    'onUpdated',
    'User',
    'Backoffice',
    'disabled_features',
    '$rootScope',
];

/* @ngInject */
function CashMovementCreateController(
    $uibModalInstance,
    Club,
    moment,
    alerts,
    serverDateTimeFormat,
    ngModel,
    onUpdated,
    User,
    Backoffice,
    disabled_features,
    $rootScope,
) {
    const parsedValues = {
        datetime:
            ngModel && ngModel.booking_id ? ngModel.booking_date : new Date(),
        value: ngModel && ngModel.value && Number(ngModel.value),
        quantity:
            ngModel && ngModel.quantity
                ? Math.abs(parseFloat(ngModel.quantity))
                : 1,
        pay_now: ngModel && !!ngModel.payed,
        payment_type: ngModel.payment_type ?? 'cash',
        item_id: ngModel.item_id ?? null,
        booking_date:
            ngModel && ngModel.datetime
                ? ngModel.datetime
                : new Date(Date.now()).toISOString(),
        court: ngModel && (ngModel.court ? ngModel.court : ''),
        player: ngModel && (ngModel.player ? ngModel.player : ''),
    };
    this.conceptSelected = !!ngModel.concept;

    this.movement = Object.assign(
        { type: 'deposit' },
        ngModel || {},
        parsedValues,
    );
    this.close = (callOnUpdated) => {
        if (callOnUpdated && onUpdated) {
            onUpdated();
        }
        $uibModalInstance.close();
    };
    this.updateMode = !this.movement || !!this.movement.id;
    this.useNow = !this.updateMode;
    this.impactCash = true;
    this.impactCashChange = (opt) => (this.impactCash = opt);
    this.useNowChange = () => {
        this.movement.pay_now = !this.movement.pay_now;
        return !this.useNow && (this.movement.datetime = new Date());
    };
    this.datepicker = {
        opened: false,
        format: 'dd-MM-yyyy',
        options: {
            maxDate: new Date(),
            showWeeks: false,
        },
    };

    this.isFetching = false;

    this.total = () => {
        if (!this.movement.value || !this.movement.quantity) {
            return 0;
        }
        return (
            parseFloat(this.movement.value) * parseFloat(this.movement.quantity)
        );
    };

    this.save = () => {
        if (!this.conceptSelected) {
            alert(
                'Debe seleccionar un concepto cargado en el Listado de Artículos',
            );
            this.movement.concept = '';
            return;
        }
        return doCall((code, user_info) =>
            (this.movement.id ? this.update : this.create)(
                withFormattedDate(code, user_info),
            ),
        );
    };

    const withFormattedDate = (code, user_info) =>
        Object.assign({}, this.movement, {
            datetime: moment(this.movement.booking_date).format(
                serverDateTimeFormat,
            ),
            code,
            user_info,
        });

    this.update = async (mov) => {
        const { user_info } = mov;
        try {
            let cash_movement_response;
            let stock_movement_response;

            if (this.movement.pay_now) {
                cash_movement_response = await this.registerCashMovement(
                    user_info,
                );
            }
            if (parsedValues.quantity !== mov.quantity) {
                stock_movement_response = await this.registerStockMovement();
            }
            try {
                await Club.CashMovementsAPI.one('general', mov.id).customPUT(
                    mov,
                );
            } catch (error) {
                await Backoffice.api.undoRegisterCarts({
                    cash_movements: cash_movement_response
                        ? [{ id: cash_movement_response.id }]
                        : [],
                    stock_movements: stock_movement_response
                        ? [{ id: stock_movement_response.id }]
                        : [],
                });

                throw new Error(
                    'A ocurrido un error inesperado. Intente nuevamente',
                );
            }
            alerts.success(
                'Exito!',
                'El movimiento fue modificado correctamente',
                {
                    timeout: 5,
                },
            );
        } catch (error) {
            alerts.error('Error!', 'Sucedio un error, intente mas tarde');
        } finally {
            $uibModalInstance.close(true);
        }
    };

    this.create = (mov) => {
        this.registerStockMovement();
        this.registerCashMovement();
        Club.CashMovementsAPI.all('general').post(mov);
        if ($rootScope.$state.current.name === 'app.reports.stock')
            $rootScope.$state.reload();
    };

    this.getUserCode = () => {
        return alerts
            .verifyCode(null, null, User)
            .then(({ code, user_info }) => ({ code, user_info }))
            .catch((error) => alerts.errorHandler(error));
    };

    this.registerBookingInfoMovement = async (mov) => {
        await Club.CashMovementsAPI.all('general').post(mov);
    };

    this.delete = () =>
        doCall((code) =>
            Club.CashMovementsAPI.one('general', this.movement.id).remove({
                code,
            }),
        );

    const getFallbackSuggestions = (criteria) => {
        this.conceptSelected = false;
        return Club.CashMovementsAPI.all('general').all('suggest').getList({
            concept: criteria,
            type: this.movement.type,
        });
    };

    const getSuggestionsNew = (criteria) =>
        Backoffice.api
            .listStockItems({
                limit: 10,
                active: true,
                q: criteria,
                operation: this.movement.type === 'deposit' ? 'sell' : 'buy',
            })
            .then((data) => {
                this.conceptSelected = false;
                return data.items.map((item) => ({
                    concept: item.name,
                    value:
                        this.movement.type === 'deposit'
                            ? item.selling_price
                            : item.buying_price,
                    type: this.movement.type,
                    item_id: item.id,
                }));
            })
            .catch((error) => {
                console.error(error);
                return getFallbackSuggestions(criteria);
            });

    this.registerStockMovement = () =>
        Backoffice.api.registerStockMovement({
            item_id: this.movement.item_id,
            value:
                this.movement.type === 'deposit'
                    ? parsedValues.quantity - this.movement.quantity
                    : this.movement.quantity,
        });

    this.registerCashMovement = (user_info = {}) => {
        const created_by = {
            user: user_info?.name ?? User.data.name,
            player: this.movement.player,
        };

        const concept_details = {
            booking_date: new Date(this.movement.booking_date).toISOString(),
            court: this.movement.court,
            booking_id: ngModel.booking_id,
        };

        return Backoffice.api.registerCashMovement({
            value: this.impactCash
                ? this.movement.type !== 'deposit'
                    ? -(this.movement.value * 100) * this.movement.quantity
                    : this.movement.value * 100 * this.movement.quantity
                : 0,
            concept: this.movement.concept,
            payment_method: this.movement.payment_type,
            comment: this.movement.note,
            created_by: JSON.stringify(created_by),
            movement_datetime: new Date().toISOString(),
            concept_details: JSON.stringify(concept_details),
            quantity: this.impactCash
                ? this.movement.quantity
                : -this.movement.quantity,
            item_id: this.movement.item_id,
        });
    };

    this.getSuggestions =
        Backoffice.canPerform('stock_item_read') &&
        !disabled_features.includes('stock_items')
            ? getSuggestionsNew
            : getFallbackSuggestions;

    this.onSuggestionSelected = (item) => {
        this.conceptSelected = true;
        const new_value = +item.value / 100;
        this.movement.item_id = item.item_id;
        this.movement.value = Math.abs(parseFloat(new_value)).toFixed(2);
        this.movement.concept = item.concept;
    };

    const doCall = (apiCall) => {
        this.loading = true;
        this.isFetching = true;
        alerts
            .verifyCode(null, null, User)
            .then(({ code, user_info }) => apiCall(code, user_info))
            .then(() => this.close(true))
            .catch((error) => alerts.errorHandler(error))
            .finally(() => {
                this.loading = false;
            });
    };
}

CreateCashMovementModal.$inject = ['$uibModal'];

function CreateCashMovementModal($uibModal) {
    return {
        open: function (edit, { onUpdated } = {}) {
            $uibModal.open({
                template: require('./cash-movement.create.component.html'),
                // size: 'sm',
                backdrop: true,
                bindToController: true,
                controller: CashMovementCreateController,
                controllerAs: 'vm',
                windowClass: 'zindex backoffice-modal',
                resolve: {
                    ngModel: edit,
                    onUpdated: () => onUpdated,
                },
            });
        },
    };
}

export default CreateCashMovementModal;
